import * as React from "react";
import Header from "../components/header";
import Gallery from "../components/gallery";
import Footer from "../components/footer";

const IndexPage = () => {
  return (
    <main style={{ backgroundColor: "#0a0a0a", minHeight: "200vh", color: "#fff" }}>
      <Header />

      <section>
        <Gallery />
      </section>

      <Footer />
    </main>
  );
};

export default IndexPage;
